import reducers from "./reducers/ReducersLookUp";
import actions from "./actions/ActionsLookUp";
import sirenActionsMapping from "./actions/SirenActions";
import templates from "./templates/TemplatesLookUp";
import { initialComponents } from "./components/InitialComponents";
import internalStateService from "./app/InternalStateService";
import translationService from "./app/TranslationService";
import utilityService from "./app/UtilityService";
import validationService from "./app/ValidationService";

let singletonEnforcer = Symbol();
let framework = Symbol();

//MAKE WEB UI GREAT AGAIN!!!
class WebUI {
    //Make WebUI singleton.
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw new Error("Cannot construct singleton");
        }

        internalStateService.addComponents(initialComponents);
        internalStateService.addActions(actions);
        internalStateService.addReducers(reducers);
        internalStateService.addSirenActionsMapping(sirenActionsMapping);
        internalStateService.addDashboardTemplates(templates);

        //WebUI Interface goes here!
        this.getComponents = internalStateService.getComponents;
        this.hasComponent = internalStateService.hasComponent;
        this.addComponents = internalStateService.addComponents;
        this.getComponentsDefaultConfig = internalStateService.getComponentsDefaultConfig;
        this.setComponentsDefaultConfig = internalStateService.setComponentsDefaultConfig;
        this.getActionsDefaultConfig = internalStateService.getActionsDefaultConfig;
        this.setActionsDefaultConfig = internalStateService.setActionsDefaultConfig;
        this.getReducers = internalStateService.getReducers;
        this.addReducers = internalStateService.addReducers;
        this.getActions = internalStateService.getActions;
        //accepts complex action names
        //example: dashboard.loadDashboardData
        this.getActionByName = internalStateService.getActionByName;
        //accept names from siren action mapping only!
        this.getSirenAction = internalStateService.getSirenAction;
        this.addActions = internalStateService.addActions;
        this.getStaticConfigUrlParser = internalStateService.getStaticConfigUrlParser;
        this.setStaticConfigUrlParser = internalStateService.setStaticConfigUrlParser;
        this.getStaticConfigLoader = internalStateService.getStaticConfigLoader;
        this.setStaticConfigLoader = internalStateService.setStaticConfigLoader;
        this.getLazyModuleLoader = internalStateService.getLazyModuleLoader;
        this.setLazyModuleLoader = internalStateService.setLazyModuleLoader;
        this.getValidations = internalStateService.getValidations;
        this.addValidations = internalStateService.addValidations;
        this.addFilters = internalStateService.addFilters;
        this.getFilters = internalStateService.getFilters;
        this.getSirenActionsMapping = internalStateService.getSirenActionsMapping;
        this.addSirenActionsMapping = internalStateService.addSirenActionsMapping;
        this.getWebConfig = internalStateService.getWebConfig;
        this.setWebConfig = internalStateService.setWebConfig;
        this.getDashboardTemplates = internalStateService.getDashboardTemplates;
        this.addDashboardTemplates = internalStateService.addDashboardTemplates;
        this.getGlobalProperty = internalStateService.getGlobalProperty;
        this.getGlobalProperties = internalStateService.getGlobalProperties;
        this.setGlobalProperties = internalStateService.setGlobalProperties;
        this.getStaticTranslation = internalStateService.getStaticTranslation;
        this.setStaticTranslation = internalStateService.setStaticTranslation;
        this.changeLocale = internalStateService.changeLocale;
        this.setConstructRequestEntityMethod = internalStateService.setConstructRequestEntityMethod;
        this.getConstructRequestEntityMethod = internalStateService.getConstructRequestEntityMethod;
        this.setSerializeMethod = internalStateService.setSerializeMethod;
        this.getSerializeMethod = internalStateService.getSerializeMethod;
        this.setDispatchMethod = internalStateService.setDispatchMethod;
        this.getDispatchMethod = internalStateService.getDispatchMethod;
        this.getOutputParser = internalStateService.getOutputParser;
        this.setOutputParser = internalStateService.setOutputParser;
        this.setInitialStoreGlobalProperties = internalStateService.setInitialStoreGlobalProperties;
        this.getInitialStoreGlobalProperties = internalStateService.getInitialStoreGlobalProperties;
        this.getComponentResolver = utilityService.getComponentResolver;
        this.getMapDispatchToProps = utilityService.getMapDispatchToProps;
        this.getMapStateToProps = utilityService.getMapStateToProps;
        this.connectComponent = utilityService.connectComponent;
        this.connectComponentTable = utilityService.connectComponentTable;
        this.connectComponentUIState = utilityService.connectComponentUIState;
        this.connectComponentChildren = utilityService.connectComponentChildren;
        this.connectApplicationLoading = utilityService.connectApplicationLoading;
        this.connectGlobalProperties = utilityService.connectGlobalProperties;
        this.connectGlobalLoading = utilityService.connectGlobalLoading;
        this.connectWidgetLoading = utilityService.connectWidgetLoading;
        this.connectFlow = utilityService.connectFlow;
        this.connectStep = utilityService.connectStep;
        this.getUtils = utilityService.getUtils;
        this.translate = translationService.translate;
        this.addTranslations = translationService.addTranslations;
        this.getValidationProperties = validationService.getValidationProperties;
        this.getValidationMethod = validationService.getValidationMethod;
        this.createContext = internalStateService.createContext;
        this.deleteContext = internalStateService.deleteContext;
        this.getWidgetContext = internalStateService.getWidgetContext;
        this.getContextConfig = internalStateService.getContextConfig;
        this.stopLogging = internalStateService.stopLogging;
        this.log = internalStateService.log;
        this.warn = internalStateService.warn;
        this.error = internalStateService.error;
    }
    static getInstance() {
        if (!this[framework]) {
            this[framework] = new WebUI(singletonEnforcer);
        }
        return this[framework];
    }
}

export default WebUI.getInstance();
